import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Rating from '../../../components/RightSidebar/Rating';

function mapStateToProps(state) {
  return {
    userId: state.getIn(['user', 'userId'])
  };
}

export default withRouter(connect(mapStateToProps)(Rating));
